import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import { RequireInitializedMember } from 'routes/utils';

const CardView =        lazy(() => import(/* webpackChunkName: "card-view" */ 'pages/card/view'));
const CardSignEdit =    lazy(() => import(/* webpackChunkName: "card-sign-edit" */ 'pages/card/sign/edit'));
const CardSendView =    lazy(() => import(/* webpackChunkName: "card-send-view" */ 'pages/card/send/view'));
const Cards =           lazy(() => import(/* webpackChunkName: "cards" */ 'pages/card/cards'));
const MyCards =         lazy(() => import(/* webpackChunkName: "my-cards" */ 'pages/my-cards'));
const CardBuilder =     lazy(() => import(/* webpackChunkName: "card-builder" */ 'pages/card/card-builder'));
const GroupCards =      lazy(() => import(/* webpackChunkName: "group-cards" */ 'pages/landings/group-cards'));
const CardSendFlow =    lazy(() => import(/* webpackChunkName: "card-send-flow" */ 'pages/card/send/flow'));

const renderCardRoutes = () => [
  <Route
    key="cards-landing"
    name="cards-landing"
    path="/cards"
    element={<Cards/>}
  />,
  <Route
    key="card-view"
    name="card-view"
    path="/card/view/:cardId"
    element={<CardView/>}
  />,
  <Route
    key="group-cards"
    name="group-cards"
    path="/group-cards"
    element={<GroupCards/>}
  />,
  <Route
    key="card-send-view"
    name="card-send-view"
    path="/card/send/view/:magicLink"
    element={<CardSendView/>}
  >
    <Route
      key="card-send-view-long"
      name="card-send-view-long"
      path=":magicLink2"
      element={<CardSendView/>}
    />,
  </Route>,
  <Route
    key="card-send-flow"
    name="card-send-flow"
    path="/card/send/:step"
    element={
      <RequireInitializedMember>
        <CardSendFlow/>
      </RequireInitializedMember>
    }
  />,
  <Route
    key="card-sign-edit"
    name="card-sign-edit"
    path="/card/sign/edit/:magicLink"
    element={<CardSignEdit/>}
  >
    <Route
      key="card-sign-edit-long"
      name="card-sign-edit-long"
      path=":magicLink2"
      element={<CardSignEdit/>}
    />,
  </Route>,
  <Route
    key="card-browser"
    name="card-browser"
    path="/cards/:topCategorySlug"
    element={<Cards/>}
  >
    <Route
      key="card-browser-mid"
      name="card-browser-mid"
      path=":midCategorySlug"
      element={<Cards/>}
    >
      <Route
        key="card-browser-sub"
        name="card-browser-sub"
        path=":subCategorySlug"
        element={<Cards/>}
      />
    </Route>
  </Route>,
  <Route
    key="card-builder"
    name="card-builder"
    path="/card/create"
    element={
      <RequireInitializedMember>
        <CardBuilder/>
      </RequireInitializedMember>
    }
  />,
  <Route
    key="my-cards"
    name="my-cards"
    path="/mycards/:myCardsType"
    element={
      <RequireInitializedMember>
        <MyCards/>
      </RequireInitializedMember>
    }
  />
];


export default renderCardRoutes;
